module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_4500_Active@1x-35c849de376de19530709d9b57d8df95.png";